import { makeStyles } from '@material-ui/core';


export default makeStyles((theme) => ({
  input: {
    borderRadius: 20,
    backgroundColor: 'white',
  },
}));
